import clsx from 'clsx';
import {
  ClientScoreHealthRangeContextProvider,
  CustomRangeSetLabel,
  GroupScoreIndicatorAwareness,
  ScoreHealthRangeBreakpointLabels,
  ScoreHealthRangeContainer,
  ScoreHealthRangeContextProvider,
  ScoreHealthRangeGraphic,
  ScoreHealthRangeGroup,
  ScoreHealthRangeGroupingContainer,
  ScoreHealthRangeScoreIndicator,
  TargetScoreRangeGraphic,
  useClientScoreHealthRange,
  UseClientScoreHealthRangeArgs,
  useScoreHealthRange,
  UseScoreHealthRangeArgs,
  useScoreHealthRangeScoreIndicator,
} from '.';
import { LocalThemeContextProvider } from '../../context';
import { displayRate, elementsColors, getFormattedNumberLabel } from '../../../util';
import { displayElementScoreRangeCategory, isScorecardTermElement } from '../../../Scorecard';
import { useTranslation } from 'react-i18next';
export interface ClientScoreHealthRangeProps extends UseClientScoreHealthRangeArgs, UseScoreHealthRangeArgs {
  className?: string;
}

export function ClientScoreHealthRange({
  firmID,
  element,
  className,
  breakpoints,
  firmClientID,
  scoreOverride,
}: ClientScoreHealthRangeProps) {
  const { t: tScorecard } = useTranslation('scorecard');
  const useScoreHealthRangeReturn = useScoreHealthRange({ element, breakpoints });
  const useClientScoreHealthRangeReturn = useClientScoreHealthRange({
    firmID,
    element,
    firmClientID,
    breakpoints,
    scoreOverride,
  });
  const useScoreHealthRangeScoreIndicatorReturn = useScoreHealthRangeScoreIndicator({
    element,
    breakpoints: useScoreHealthRangeReturn.breakpoints,
    numberOfSections: useScoreHealthRangeReturn.numberOfSections,
    householdID: useClientScoreHealthRangeReturn.householdID ?? '',
    scoreOverride,
  });

  return (
    <ScoreHealthRangeContextProvider element={element} {...useScoreHealthRangeReturn}>
      <ClientScoreHealthRangeContextProvider {...useClientScoreHealthRangeReturn}>
        <LocalThemeContextProvider paletteSeedColor={elementsColors[element]}>
          <ScoreHealthRangeContainer className={className}>
            <ScoreHealthRangeBreakpointLabels
              displayBreakpoints={useScoreHealthRangeReturn.displayBreakpoints.map((point) =>
                isScorecardTermElement(element)
                  ? getFormattedNumberLabel(point) ?? ''
                  : displayRate(point, { withSymbol: true })
              )}
            />
            <ScoreHealthRangeGraphic
              targetScoreRangeGraphic={<TargetScoreRangeGraphic />}
              numberOfSections={useScoreHealthRangeReturn.numberOfSections}
              scoreHealthRangeIndicator={
                <ScoreHealthRangeScoreIndicator
                  isLoading={useScoreHealthRangeScoreIndicatorReturn.isLoading}
                  leftStyle={useScoreHealthRangeScoreIndicatorReturn.leftStyle}
                  scoreDisplay={useScoreHealthRangeScoreIndicatorReturn.scoreDisplay}
                />
              }
              className={clsx('[&_.ScoreHealthRangeGraphic-Line]:!bg-palette-600/20')}
            />
            <ScoreHealthRangeGroupingContainer>
              {useScoreHealthRangeReturn.breakpoints.map(
                (breakpoint) =>
                  breakpoint.category &&
                  breakpoint.id && (
                    <GroupScoreIndicatorAwareness
                      key={breakpoint.id}
                      isScoreWithinBreakpoint={useClientScoreHealthRangeReturn.isScoreWithinBreakpoint(breakpoint)}
                    >
                      <ScoreHealthRangeGroup
                        role="none"
                        className="pointer-events-none"
                        groupDisplay={displayElementScoreRangeCategory(breakpoint.category, tScorecard)}
                      />
                    </GroupScoreIndicatorAwareness>
                  )
              )}
            </ScoreHealthRangeGroupingContainer>
            <CustomRangeSetLabel />
          </ScoreHealthRangeContainer>
        </LocalThemeContextProvider>
      </ClientScoreHealthRangeContextProvider>
    </ScoreHealthRangeContextProvider>
  );
}
